import { render, staticRenderFns } from "./CurrentWipStock.vue?vue&type=template&id=6ab5a8da&"
import script from "./CurrentWipStock.vue?vue&type=script&lang=js&"
export * from "./CurrentWipStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports